<template>
    <div>
        <center>
      <div class="row">
        <div class="col-md-12">
          <p>
            Paciente
            <i class="fa fa-users"></i>
          </p>
        </div>
        <div class="col-md-6">
          <select class="form-control select-sm" id v-model="criterio">
            <option value="PacApe1">Apellidos del paciente</option>
            <option value="PacNom1">Nombres del paciente</option>
          </select>
        </div>
        <div class="col-md-4">
          <input type="text" class="form-control input-sm" @keyup.enter="buscarPacientes()" v-model="busqueda" />
        </div>
        <div class="col-md-2">
          <button class="btn btn-link btn-icon btn-simple" @click="buscarPacientes()">
            <i class="fa fa-search"></i>
          </button>
          <!-- <button class="btn btn-simple btn-icon btn-danger" @click="limpiarPaciente()">
            <i class="fa fa-refresh"></i>
          </button> -->
        </div>
      </div>
    </center>
    <center>
      <div class="row" v-if="buscar == false">
        <div>
          <br>
          <el-table :data="arrayPacientes" border style="width: 97%" size="mini"  class="table-responsive">
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="PacApe1" label="Apellidos"></el-table-column>
            <el-table-column prop="PacNom1" label="Nombres"></el-table-column>
            <el-table-column prop="PacNumDoc" label="Numero de documento"></el-table-column>
            <el-table-column prop="TipCliNom" label="Tipo de cliente"></el-table-column>
            <el-table-column label width="100">
                 <template slot-scope="props">
                <center>
                  <a
                  class="btn btn-simple btn-success btn-xs btn-icon like"
                  @click="seleccionarPaciente(props.row)"
                  v-if="props.row.estado==1"
                >
                  <i class="fa fa-check"></i>
                </a>
                <small v-else class="text-danger">INACTIVO</small>
                </center>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </center>
    <center>
      <div class="row" v-if="nombre != ''">
        <div class="col-md-6">
          <label for>Nombre</label>
          <input type="text" class="form-control input-sm" disabled v-model="nombre" />
          <small class="text-danger" v-if="alertTipoCliente">El tipo de cliente no concueda con el modulo seleccionado</small>
        </div>
        <div class="col-md-4">
          <label for>Documento</label>
          <input type="text" class="form-control input-sm" disabled v-model="documento" />
        </div>
        <div class="col-md-2 text-success">
          <label for>Cod. único</label>
          <p style="font-size:19px;">{{ pacIde }}</p>
        </div>
      </div>
    </center> <br>
    <center>
        <div class="row">
            <p>Información del servicio <i class="fa fa-file"></i></p>
        </div>
        <div class="row">
            <div class="col-md-3">
                <label for="">Numero del servicio:</label>
                <input type="text" class="form-control input-sm" disabled v-model="numeroAutorizacion">
            </div>
             <div class="col-md-3">
                 <label for="">Fecha inicio</label>
                <input type="date" class="form-control input-sm" @change="generarCodigo()" v-model="fechaExpedicion">
            </div>
            <div class="col-md-3">
                 <label for="">Cobertura:</label>
                <select v-model="cobertura" class="select-sm form-control" id="">
                    <option value="45">45 Dias</option>
                    <option value="30">1 Mes</option>
                    <option value="60">2 Meses</option>
                    <option value="90">3 Meses</option>
                    <option value="120">4 Meses</option>
                    <option value="150">5 Meses</option>
                    <option value="180">6 Meses</option>
                    <!-- <option value="">Sin vigencia</option> -->
                </select>
            </div>
             <div class="col-md-3">
                 <label for="">Numero° orden <small>(opcional)</small></label>
                <input type="text" class="form-control input-sm" v-model="numeroOrden">
            </div>
        </div> <br>
        <div class="row">
            <p>Información de cliente <i class="fa fa-user"></i></p>
        </div>
        <div class="row">
            <div class="col-md-3">
                <label for="">Cliente/convenio</label>
                <select class="form-control select-sm" v-model="nombreCliente" id="">
                    <option value="">
                        convenio 1
                    </option>
                </select>
            </div>
            <div class="col-md-3">
                <label for="">Observaciones: <small>(opcional)</small> </label>
               <textarea type="text" v-model="observaciones" class="input-sm form-control"></textarea>
            </div>
        </div>
    </center> <br>

    <center>
        <div class="row">
       <form @submit.prevent="agregarServicios">   
        <div class="col-md-4">
          <label>Servicio</label>
          <select class="form-control select-sm" v-model="especialidad">
              <option :value="especialidad.EspCod" v-for="especialidad in arrayEspecialidad" :key="especialidad.EspCod">
                  {{especialidad.EspNom}}
              </option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Cantidad</label>
          <input type="text" class="form-control input-sm" v-model="cantidad" required />
        </div>
        <div class="col-md-1">
          <label for style="color:white;">---</label>
          <button type="submit" class="btn btn-icon btn-simple btn-success">
            <i class="fa fa-plus"></i>
          </button>
        </div>
        </form>
      </div> <br>
        <div class="row" v-if="arrayCantidad!=''">
       <el-table
          :data="arrayCantidad"
          border
          style="width: 50%"
          class="table-responsive table-bordered"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="servicio" label="Cups" ></el-table-column>
          <el-table-column prop="cantidad" label="Cantidad" ></el-table-column>
           <el-table-column  label="" width="50">
             <template slot-scope="props">
                <!-- <a class="btn btn-simple btn-xs btn-info btn-icon like" @click="handleLike(props.$index, props.row)"><i class="ti-heart"></i></a> -->
                <!-- <a class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a> -->
                <a class="btn btn-simple btn-xs btn-danger btn-icon remove"  @click="eliminarServicio(props.$index, props.row)"><i class="ti-close"></i></a>
              </template>
           </el-table-column>
        </el-table> <br>
      </div>
    </center> <br>
    <center>
        <button class="btn btn-success btn-sm" @click="nuevaParticular()">Registrar servicio para convenio</button>
        <button class="btn btn-danger btn-sm" @click="cerrar()"> <i class="fa fa-close"></i> Cancelar</button>
    </center> <br> <br> <br>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data(){
        return {
            criterio: "PacApe1",
            buscar: true,
            arrayPacientes: [],
            busqueda: "",
            ip: "https://avanti-erp.com/",
            nombre: "",
            documento: "",
            pacIde: "",
            alertTipoCliente: false,
            numeroAutorizacion: '',
            fechaExpedicion: '',
            numeroOrden: '',
            numeroContrato: '',
            cliente: '',
            formaPago: '',
            bolsa: 0,
            periodo: '',
            observaciones: '',
            arrayCantidad: [],
            arrayEspecialidad: [],
            fechaVencimientoAutorizacion: '',
            cobertura: '',
            especialidad: [],
            cantidad: '',
            type: ['', 'info', 'success', 'warning', 'danger'],
                notifications: {
                topCenter: false
            },

        }
    },
    methods: {
      eliminarServicio: function (index, fila) {
        this.arrayCantidad.splice(index, 1);
       this.bolsa = this.bolsa - parseInt(fila.cantidad)
      console.log('Bolsa', this.bolsa);
      },
        buscarPacientes() {
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      this.arrayPacientes = [];
      let vm = this;
      var url =
        this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      axios
        .get(url, config)
        .then(response => {
          vm.arrayPacientes = response.data.data;
          this.buscar = false;
          console.log(response.data.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    seleccionarPaciente(paciente) {
      if(paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")){
        const alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
      if(alerta == true){
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = true;

        setTimeout(() => {
          this.cargarOrdenes();
        }, 1000);
      }
      }else{
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;

        setTimeout(() => {
          this.cargarOrdenes();
        }, 1000);
      }
    },
    generarCodigo(){
        this.numeroAutorizacion = 'CON-'+this.pacIde+'-'+this.fechaExpedicion;
    },
    selectEspecialidad() {
        var token = localStorage.getItem('token');
         let config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip+"api/selectEspecialidad";
      axios
        .get(url, config)
        .then(response => {
          var respuesta = response.data.data;
          this.arrayEspecialidad = respuesta;
        })
        .catch(error => {
          console.log(error);
        });
    },
    agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad,
          cantidad: this.cantidad
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        this.cantidad = "";
        this.especialidad = "";
      }
    },

    nuevaParticular(){
      if(this.bolsa == 0){
        alert('Debe cargar servicios a la autorización')
      }else{
          this.calcularFecha();
       let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem('token')
        }
        }
        var url = this.ip+'api/nuevoParticular';
        axios.post(url, {
            paciente : this.pacIde,
            codigo : this.numeroAutorizacion,
            servicio : 'convenio',
            entidad : 16,
            fecha : this.fechaExpedicion,
            cobertura: this.cobertura,
            fechaVencimiento : this.fechaVencimientoAutorizacion,
            formato : 3,
            nombre_cliente : this.nombre_cliente,
            servicios: this.arrayCantidad,
            bolsa: this.bolsa,
            usuario: localStorage.getItem("usuario"),
        }, config).then(response =>{
            var color = Math.floor((Math.random() * 4) + 1)
            this.$notify(
                {
                  component: {
                    template: `<span>!<b> Servicio registrado con éxito!</b>.</span>`
                  },
                  icon: 'ti-check',
                  horizontalAlign: 'right',
                  verticalAlign: 'top',
                  type: this.type[color]
            });
            this.pacIde = '';
            this.fechaExpedicion = '';
            this.numeroAutorizacion = '';
            this.cobertura = '';
            this.fechaVencimientoAutorizacion = '';
            this.nombre_cliente = '';
            this.periodo = '';
            this.formaPago = '';
            this.numeroContrato = '';
            this.observaciones = '';
            this.arrayCantidad = [];
            this.bolsa = 0;
            this.cerrar();
        }).catch(error =>{
            console.log(error);
        })
      }
      
    },

    calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);
      // this.fechaVencimiento = fechaFin.getDate() + '/' + (fechaFin.getMonth() + 1) + '/' + fechaFin.getFullYear();
      // this.fechaVencimiento = new Date("2019/10/21");
      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
    //   if (mes < 10 && dia < 10) {
    //     // this.fechaVencimiento = ano + "-" + "0" + mes + "-" + "0" + dia;
    //     this.fechaVencimientoAutorizacion = ano + "-" + "0" + mes + "-" + "0" + dia;
    //   } else {
    //     // this.fechaVencimiento = ano + "-" + mes + "-" + dia;
    //     this.fechaExpedicionAutorizacion = ano + "-" + mes + "-" + dia;
    //   }
      if(dia < 10){
          dia = '0'+dia;
      }
      if(mes < 10){
          mes = '0'+mes;
      }
      this.fechaVencimientoAutorizacion = ano+ '-' + mes + '-' + dia;
    },

    cerrar(){
        this.$modal.hide('ingreso_servicio');
    }
        
    },
    mounted() {
        this.selectEspecialidad();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Admisiones/formularios/convenio.vue